const initialState = {}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'STATUS_GET': {
            return {
                ...state,
                platform: null,
            }
        }
        case 'STATUS_GET_SUCCESS': {
            return {
                ...state,
                ...action.payload,
            }
        }
        case 'STATUS_GET_FAILURE': {
            return {
                ...state,
                platform: null,
            }
        }
        case 'CLEAN_STATUS': {
            return {
                ...state,
                shopAlias: null,
            }
        }
        default:
            return { ...state }
    }
}
